var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9353 41.9382C16.2412 41.9382 10.5471 39.9618 6.40588 35.7618C-2.13529 27.6088 -2.13529 14.2676 6.40588 6.11471C14.9471 -2.03824 28.9235 -2.03824 37.4647 6.11471C46.0059 14.2676 46.0059 27.6088 37.4647 35.7618C33.3235 39.9618 27.6294 41.9382 21.9353 41.9382ZM8.21765 34.0324C15.7235 41.1971 28.1471 41.1971 35.6529 34.0324C43.1588 26.8676 43.1588 15.0088 35.6529 7.84412C28.1471 0.679411 15.7235 0.679411 8.21765 7.84412C0.711764 15.0088 0.711764 26.8676 8.21765 34.0324Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9235 22.1737H14.9471C14.1706 22.1737 13.653 21.6796 13.653 20.9384C13.653 20.1972 14.1706 19.7031 14.9471 19.7031H28.9235C29.7 19.7031 30.2177 20.1972 30.2177 20.9384C30.2177 21.6796 29.7 22.1737 28.9235 22.1737Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIconGrey);
export default __webpack_public_path__ + "static/media/remove-icon-grey.511846aefbd0d11ad4fa85a3de01560a.svg";
export { ForwardRef as ReactComponent };